<template>
  <div class="text-center mb-1">
    <template v-if="showWelcomeMessage !== null">
      <h5 class="mb-1 text-primary">
        {{ showWelcomeMessage }}
      </h5>
    </template>
    <GjIcon
      class="mb-1"
      name="Globe"
      size="57"
    />
    <template v-if="hasProjects">
      <h5 class="mb-1 text-main">
        Choose a project
      </h5>
    </template>
    <template v-else>
      <h5 class="mb-1 text-main">
        Create a new Project
      </h5>
    </template>

    <p
      v-if="hasProjects"
      class="col-12 col-md-8 text-center m-auto text-secondary mb-3"
    >
      You cannot move servers from one project to another once deployed.
    </p>
  </div>
</template>
<script>
export default {
  name: 'OrganizationViewHeader',
  props: {
    hasProjects: {
      type: Boolean,
      require: true,
    },
    showWelcomeMessage: {
      type: String,
      default: null,
    },
  },
}
</script>
